<tn-dialog-shell testId="update" [title]="contentText.title | translate">
  <p class="dialog-message">
    <span [innerHTML]="contentText.message | translate"></span>
  </p>

  @let jobs = selectRunningJobs$ | async;
  <div class="jobs">
    @if (jobs?.length) {
      <div>
        @for (job of jobs; track job) {
          <ix-job-item [job]="job"></ix-job-item>
        }
      </div>
    }
  </div>
</tn-dialog-shell>
